<template>
  <div class="advanced-material">
    <el-switch
      v-model="enabled"
      active-text="开启"
      inactive-text=""
      @change="onChange"
    ></el-switch>
    <p class="advanced-material-desc">
      开启进阶赋能型素材后，系统会自动优化你的创意素材，以便为查看广告的用户定制个性化体验。系统会展示创意优化版本或原创意，具体取决于系统预测哪个创意将最大限度地提升广告表现。
    </p>
  </div>
</template>

<script>
export default {
  name: 'AdvancedMaterial',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    enabled: {
      get() {
        return this.value === undefined ? true : this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
  },
  methods: {
    onChange(val) {
      this.$emit('change', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.advanced-material {
  .advanced-material-desc {
    font-size: 12px;
    color: #999;
    line-height: 1.6;
    margin: 8px 0 0 0;
  }
}
</style>
